import React, { useState, useEffect } from 'react';

declare global {
  interface Window { AjaxZip3: any; }
}

const modalPreview = (props) => {
　
  const icon =  require("../../../images/hearing_icon.png");
  const humanImge =  require("../../../images/body_blank_figure_front.png");

  const [currentAnswerList, setCurrentAnswerList] = useState(	{
		m_template_id: 1,
		interviewDetailId: 1,
		isComplete: false,
		isEditMode: false,
		isRegistered: false,
		questions: [
			{
				partGroupId: 1,
				answers: [
					{ partFieldId: 1, value: "", label: "", formName: "", arrValue: [], imgValue: [],isAnswerRequired: false},
					{ partFieldId: 2, value: "", label: "", formName: "", arrValue: [], imgValue: [],isAnswerRequired: false},
				]
			}
		]
	});
  const [isAutocomplete, setIsAutocomplete] = useState(true);
  const [update, setUpdate] = useState<Boolean>(false);

  // 画像アップロード
  function addFileInput(questionNumber, idx) {
    const upload_button = document.getElementById("upload_inteview_photo");
    if(currentAnswerList.questions[questionNumber].answers[idx].imgValue.length >= 5){
      return;
    }else{
      upload_button.click();
    }
  }

  // 画像の削除処理
  const onRemove = (question_number, idx, file_name) => {
    const currentAnswerListDup = currentAnswerList;
    currentAnswerListDup.questions[question_number].answers[idx].imgValue.map((img, i)=>{
      img.fileName === file_name && currentAnswerListDup.questions[question_number].answers[idx].imgValue.splice(i,1)
    })
    setCurrentAnswerList(currentAnswerListDup);
    setUpdate(update?false:true);
  }

  const onChangeInputFile = (e, questionNumber, idx) => {
    const currentAnswerListDup = currentAnswerList;

    if (e.target.value) {
      const file_type = e.target.files[0].type;
      const file_name = e.target.files[0].name;
      
      const reader = new FileReader();
      reader.onload = function (e) {
          const image_value = { fileType: file_type, fileName: file_name, imgPath: `${e.target.result}` }
          currentAnswerListDup.questions[questionNumber].answers[idx].imgValue.push(image_value);
          setCurrentAnswerList(currentAnswerListDup);
          setUpdate(update?false:true);
      }
      reader.readAsDataURL(e.target.files[0]);
    }
  }

  // 日付変更
  // 本当はuseEffectで行いたいがいい方法が見つからず
  function changeDate(target){
    // 年が入力されたタイミング
    if (isAutocomplete && target.value.match(/^[0-9]{4}$/)) {
      target.value = target.value + "-";
      setIsAutocomplete(false);
    }

    // 月が入力されたタイミング
    if (isAutocomplete && target.value.match(/^[0-9]{4}-[0-9]{2}$/)) {
      target.value = target.value + "-";
      setIsAutocomplete(false);
    }

    // 年または月の入力が完了しそうなタイミング
    if (
      target.value.match(/^[0-9]{3}$/) ||
      target.value.match(/^[0-9]{4}-[0-9]{1}$/)
    ) {
      setIsAutocomplete(true);
    }

    // 補完直後
    if (
      target.value.match(/^[0-9]{4}-$/) ||
      target.value.match(/^[0-9]{4}-[0-9]{2}\/$/)
    ) {
      setIsAutocomplete(false);
    }
  }

  // part表示
  function partFieldView(partField, idx){
    switch(partField.inputtype_kbn){
      case 1:
        {/* ラジオボタン */}
        return(
          <>
            <div className="col-md-12 col-sm-12 col-xs-12 text-left">
              <label className="interview-input-label">※どれかひとつ選択してください。</label>
            </div>
            <div className="col-md-12 col-sm-12 col-xs-12 text-left">
              <label className="interview-input-label">{ partField.display_web_name }</label>
              {partField.is_answer_required && <span className="label label-danger ml5">必須</span>}
            </div>
            <div className="text-center row">  
              {partField.m_part_field_options.map((option, count) => {
                return(
                  <div className="col-md-6 col-sm-6 col-xs-12">
                    <input 
                      key={"radio_" + idx + "_" + count}
                      type="radio"
                      name={"radio_" + idx}
                      className="display-none interview-radio" 
                      id={"radio_" + idx + "_" + count}
                    />
                    <label htmlFor={"radio_" + idx + "_" + count} className="radio-button">{option.title}</label>
                  </div>

                )
              })}
            </div>
            <div className="interview-font-color col-md-12 col-sm-12 col-xs-12">
              {partField.description}
            </div>
          </>
        )
      case 4:
        {/* テキストエリア */}
        return(
          <>
            <div className="col-md-12 col-sm-12 col-xs-12 text-left padding0">
              <label className="interview-input-label">{ partField.display_web_name }</label>
              {partField.is_answer_required && <span className="label label-danger ml5">必須</span>}
            </div>
            <div className="text-center row">
              <div className="col-md-12 col-sm-12 col-xs-12">
                <textarea
                  key={"textarea_" + idx}
                  className="form-control text-area-width"
                  id={"textarea_" + idx}
                  rows={4}
                  placeholder={partField.placeholder}
                  maxLength={1000}
                />
              </div>  
            </div>
            <div className="interview-font-color col-md-12 col-sm-12 col-xs-12">
              {partField.description}
            </div>
          </>
        )
      case 2:
        {/* チェックボックス */}
        return(
          <>
            <div className="col-md-12 col-sm-12 col-xs-12 text-left">
              <label className="interview-input-label">※複数選択できます。</label>
            </div>
            <div className="col-md-12 col-sm-12 col-xs-12 text-left">
              <label className="interview-input-label">{ partField.display_web_name }</label>
              {partField.is_answer_required && <span className="label label-danger ml5">必須</span>}
            </div>    
            <div className="text-center row" key={"checkbox_" + idx}>
              {partField.m_part_field_options.map((option, count) => {
                return(
                  <div className="col-md-6 col-sm-6 col-xs-12">
                    <input 
                      key={"checkbox_" + idx + "_" + count}
                      type="checkbox" 
                      className="display-none medical-history-checkbox" 
                      id={"checkbox_" + idx + "_" + count}
                    />
                    <label className="checkbox-button" htmlFor={"checkbox_" + idx + "_" + count}>{option.title}</label>
                  </div>
                )
              })}
            </div>
            <div className="interview-font-color col-md-12 col-sm-12 col-xs-12">
              {partField.description}
            </div>
          </>
        )
        // インプット（文字列）  
        case 3:
          return(
            <>
              <div className="col-md-12 col-sm-12 col-xs-12 text-left">
                  <label className="interview-input-label">{ partField.display_web_name }</label>
                  {partField.is_answer_required && <span className="label label-danger ml5">必須</span>}
              </div>

              <div className="text-center row">
                <div className="col-md-3 col-sm-3 d-xs-none text-right">
                    <label className="interview-input-label">{ partField.display_left }</label>
                </div>
                <div className="text-left col-xs-12 d-none">
                  <label className="interview-input-label">{ partField.display_left }</label>
                </div>
                <div className="form-group col-md-6 col-sm-6 col-xs-12">
                  <input
                    key={"input_string_" + idx}
                    type="text"
                    className="form-control"
                    autoComplete="off"
                    maxLength={255}
                    placeholder={partField.placeholder}
                  />
                </div>
                <div className="col-md-3 col-sm-3 d-xs-none text-left">
                  <label className="interview-input-label">{ partField.display_right}</label>
                </div>
                <div className="text-right col-xs-12 d-none">
                  <label className="interview-input-label">{ partField.display_right}</label>
                </div>
              </div>
            </>  
          )
          // インプット（数値） 
          case 5:
            return(
              <div className="row interview-input-form">
                <div className="col-md-12 col-sm-12 col-xs-12 text-left">
                    <label className="interview-input-label">{ partField.display_web_name }</label>
                    {partField.is_answer_required && <span className="label label-danger ml5">必須</span>}
                </div>

                <div className="col-md-3 col-sm-3 d-xs-none text-right">
                    <label className="interview-input-label">{ partField.display_left }</label>
                </div>
                <div className="text-left col-xs-12 d-none">
                  <label className="interview-input-label">{ partField.display_left }</label>
                </div>
                <div className="col-md-6 col-sm-6 col-xs-12">
                  <input
                    key={"input_number_" + idx}
                    type="number"
                    id={"input_number_" + idx}
                    className="form-control"
                    autoComplete="off"
                  />
                </div>
                <div className="col-md-3 col-sm-3 d-xs-none text-left">
                  <label className="interview-input-label">{ partField.display_right}</label>
                </div>
                <div className="text-right col-xs-12 d-none">
                  <label className="interview-input-label">{ partField.display_right}</label>
                </div>
              </div>
            )
          // インプット（小数点）  
          case 6:
            return(
              <div className="row interview-input-form">
                <div className="col-md-12 col-sm-12 col-xs-12 text-left">
                    <label className="interview-input-label">{ partField.display_web_name }</label>
                    {partField.is_answer_required && <span className="label label-danger ml5">必須</span>}
                </div>

                <div className="col-md-3 col-sm-3 d-xs-none text-right">
                    <label className="interview-input-label">{ partField.display_left }</label>
                </div>
                <div className="text-left col-xs-12 d-none">
                  <label className="interview-input-label">{ partField.display_left }</label>
                </div>
                <div className="col-md-6 col-sm-6 col-xs-12">
                  <input
                    key={"input_decimal_" + idx}
                    type="number"
                    id={"input_decimal_" + idx}
                    className="form-control"
                    autoComplete="off"
                  />
                </div>
                <div className="col-md-3 col-sm-3 d-xs-none text-left">
                  <label className="interview-input-label">{ partField.display_right}</label>
                </div>
                <div className="text-right col-xs-12 d-none">
                  <label className="interview-input-label">{ partField.display_right}</label>
                </div>
              </div>
            )                                  
          // セレクトリスト 
          case 25:
            return(
              <div className="from-group">
                <label className="interview-input-label" htmlFor={"select_" + idx}>{partField.display_web_name}</label>
                {partField.is_answer_required && <span className="label label-danger ml5">必須</span>}
                <div className="row">
                  <div className="col-md-3 col-sm-3 d-xs-none text-right">
                    <label className="interview-input-label">{ partField.display_left }</label>
                  </div>
                  <div className="text-left col-xs-12 d-none">
                    <label className="interview-input-label">{ partField.display_left }</label>
                  </div>                  
                  <div className="col-md-6 col-sm-6 col-xs-12">
                    <select 
                      className="form-control interview-input-label" 
                      id={"select_" + idx}
                    >
                      
                      {partField.m_part_field_options.map((option) => {
                        return(
                          <>
                            <option> {option.title} </option>
                          </>
                        )
                      })}
                    </select>
                  </div>
                  <div className="col-md-3 col-sm-3 col-xs-12 text-left">
                    <label className="interview-input-label">{ partField.display_right }</label>
                  </div>  
                </div>
                <div className="interview-font-color col-md-12 col-sm-12 col-xs-12">
                  {partField.description}
                </div>
              </div>
            )
          // 日付
          case 8:
            return(
              <>
                <div className="col-md-12 col-sm-12 col-xs-12 text-left">
                    <label className="interview-input-label">{ partField.display_web_name }</label>
                    {partField.is_answer_required && <span className="label label-danger ml5">必須</span>}
                </div>
  
                <div className="text-center row">
                  <div className="col-md-3 col-sm-3 d-xs-none text-right">
                      <label className="interview-input-label">{ partField.display_left }</label>
                  </div>
                  <div className="text-left col-xs-12 d-none">
                    <label className="interview-input-label">{ partField.display_left }</label>
                  </div>
                  <div className="form-group col-md-6 col-sm-6 col-xs-12">
                  <input
                    key={"input_date_" + idx}
                    type="tel"
                    className="form-control"
                    autoComplete="off"
                    maxLength={10}
                    placeholder={partField.placeholder}
                    onChange={(e) => changeDate(e.target)}
                  />
                  </div>
                  <div className="col-md-3 col-sm-3 d-xs-none text-left">
                    <label className="interview-input-label">{ partField.display_right}</label>
                  </div>
                  <div className="text-right col-xs-12 d-none">
                    <label className="interview-input-label">{ partField.display_right}</label>
                  </div>
                  <div className="col-md-12">
                  <label className="interview-input-label">(例) 1985-01-01 ※「-」は自動で入力されます。</label>
                  </div>
                </div>
              </>  
            )
          // 写真
          case 10:
            return(
              <>
                <div className="col-md-12 col-sm-12 col-xs-12 text-left">
                  <label className="interview-input-label">{ partField.display_web_name }</label>
                  {partField.is_answer_required && <span className="label label-danger ml5">必須</span>}
                </div>
                <div className="col-md-12 col-sm-12 col-xs-12 text-right">
                  {
                  <button className="btn btn-interview add-prescription-btn" disabled={currentAnswerList.questions[0].answers[idx].imgValue.length >= 5 } onClick={() => addFileInput(0, idx)}>
                    <span className="glyphicon glyphicon-camera mr10" aria-hidden="true"></span>
                    写真を撮る（ファイル添付）
                  </button>
                  }

                  <input 
                    type="file" 
                    key={"image_" + idx}
                    id="upload_inteview_photo"
                    accept="image/*"
                    className="interview-file-input hidden"
                    onChange={(e) => onChangeInputFile(e,0, idx)} 
                  />
                  <br/>
                  <div className="well">
                    <div id="file_input_area" className="interview-img-area" >
                      {
                        currentAnswerList.questions[0].answers[idx].imgValue.map((imgValue) => {
                          return(
                            <div id={`custom_${imgValue.fileName}`} className="col-md-2">
                              <span>
                                <span className="btn">
                                  <span className="glyphicon glyphicon-trash" onClick={() => onRemove(0, idx, imgValue.fileName)}/>
                                </span>
                              </span>
                              <span className="preview-content">
                                <img id={`preview_${imgValue.fileName}`}
                                  className="preview-img interview-upload-file"
                                  src={imgValue.imgPath}
                                />
                              </span>
                            </div>
                          )
                        })
                      }
                    </div>  
                    </div>
                  </div>
              </>
            )

          // 電話番号
          case 21:
            return(
              <div className="row interview-input-form">
                <div className="col-md-12 col-sm-12 col-xs-12 text-left">
                    <label className="interview-input-label">{ partField.display_web_name }</label>
                    {partField.is_answer_required && <span className="label label-danger ml5">必須</span>}
                </div>

                <div className="col-md-3 col-sm-3 d-xs-none text-right">
                    <label className="interview-input-label">{ partField.display_left }</label>
                </div>
                <div className="text-left col-xs-12 d-none">
                  <label className="interview-input-label">{ partField.display_left }</label>
                </div>
                <div className="col-md-6 col-sm-6 col-xs-12">
                  <input
                    key={"input_phone_" + idx}
                    type="tel"
                    id={"input_phone_" + idx}
                    className="form-control"
                    autoComplete="off"
                    maxLength={13}
                    placeholder={partField.placeholder}
                  />
                </div>
                <div className="col-md-3 col-sm-3 d-xs-none text-left">
                  <label className="interview-input-label">{ partField.display_right}</label>
                </div>
                <div className="text-right col-xs-12 d-none">
                  <label className="interview-input-label">{ partField.display_right}</label>
                </div>
              </div>
            )
            // 画像チェックボックス
            case 26:
              return(
                <>
                  <div className="col-md-12 col-sm-12 col-xs-12 text-left">
                  <label className="interview-input-label">※複数選択できます。</label>
                  </div>
                  <div key={"img_checkbox_" + idx}>
                    <div className="row row-height-flex">
                      <div className="text-center col-xs-12 d-none">
                        <img src={humanImge} className="human-img" alt="アイコン"></img>
                      </div>
                      <div className="col-md-4 col-sm-4 col-xs-12 margin-auto">
                        {partField.m_part_field_options.map((option, count) => {
                          return(
                            <>
                            { count % 2 === 0 && (
                              <>
                                <input 
                                  key={"img_checkbox_" + idx}
                                  type="checkbox" 
                                  className="display-none medical-history-checkbox" 
                                  id={"img_checkbox_" + idx + "_" + count}
                                />
                                <label className="checkbox-button" htmlFor={"img_checkbox_" + idx + "_" + count}>{option.title}</label>
                              </>  
                              )}
                            </>
                          )
                        })}
                      </div>  
                      <div className="col-md-4 col-sm-4 d-xs-none text-center">
                        <img src={humanImge} className="human-img" alt="アイコン"></img>
                      </div>
                      <div className="col-md-4 col-sm-4 col-xs-12 margin-auto">
                        {partField.m_part_field_options.map((option, count) => {
                          return(
                            <>                                        
                              { count % 2 === 1 && (
                                <>
                                  <input 
                                    key={"img_checkbox_" + idx}
                                    type="checkbox" 
                                    className="display-none medical-history-checkbox" 
                                    id={"img_checkbox_" + idx + "_" + count}
                                  />
                                  <label className="checkbox-button" htmlFor={"img_checkbox_" + idx + "_" + count}>{option.title}</label>
                                </>  
                              )}
                            </>
                        )
                        })}
                      </div>  
                    </div>
                  </div>
                </>
              )

      }
  }

  // 特殊アンケート
  function specialPartFieldView(part, part_fields) {
    switch(part.part_kbn){
      case 4:
       // 住所テンプレート
       return(
        <>
          <div className="row interview-input-form">
            <div className="col-md-5 col-sm-5 d-xs-none text-right">
              <label className="interview-input-label">{ part_fields[0].display_left }</label>
            </div>
            <div className="text-left col-xs-12 d-none">
              <label className="interview-input-label">{ part_fields[0].display_left }</label>
            </div>
            <div className="col-md-6 col-sm-6 col-xs-12">
              <input
                key="special_part_4_0"
                type="tel"
                id="special_part_4_0"
                name="zipCode"
                className="form-control"
                autoComplete="off"
                maxLength={8}
                placeholder={part_fields[0].placeholder}
              />
            </div>
          </div>  
          <div className="row interview-input-form">
            <div className="col-md-5 col-sm-5 d-xs-none text-right">
              <label className="interview-input-label">{ part_fields[1].display_left }</label>
            </div>
            <div className="text-left col-xs-12 d-none">
              <label className="interview-input-label">{ part_fields[1].display_left }</label>
            </div>
            <div className="col-md-6 col-sm-6 col-xs-12">
              <input
                key="special_part_4_1"
                type="text"
                id="address1"
                name="address1"
                className="form-control"
                autoComplete="off"
                maxLength={255}
                placeholder={part_fields[1].placeholder}
              />
            </div>
          </div>  

          <div className="row interview-input-form">
            <div className="col-md-5 col-sm-5 d-xs-none text-right">
              <label className="interview-input-label">{ part_fields[2].display_left }</label>
            </div>
            <div className="text-left col-xs-12 d-none">
              <label className="interview-input-label">{ part_fields[2].display_left }</label>
            </div>
            <div className="col-md-6 col-sm-6 col-xs-12">
              <input
                key="special_part_4_2"
                type="text"
                id="address2"
                name="address2"
                className="form-control"
                autoComplete="off"
                maxLength={255}
                placeholder={part_fields[2].placeholder}
              />
            </div>            
          </div>
        </>
       )
      case 5:
        // 喫煙テンプレート
        return(
          <>
            {/* スマートフォン用テンプレート */}
            <div className="d-none">
              <div className="col-xs-12">
                <input 
                  key="sp_special_part_5_0_0"
                  type="radio" 
                  name="optradio_sp" 
                  className="display-none interview-radio" 
                  id="sp_special_part_5_0"
                />
                <label htmlFor="sp_special_part_5_0" className="radio-button">{part_fields[0].m_part_field_options[0].title}</label>
              </div>

              <div className="col-xs-12">
                <input 
                  key="sp_special_part_5_0_1"
                  type="radio" 
                  name="optradio_sp" 
                  className="display-none interview-radio" 
                  id="sp_special_part_5_0_1"
                />
                <label htmlFor="sp_special_part_5_0_1" className="radio-button">{part_fields[0].m_part_field_options[1].title}</label>
              </div>

              <div className="col-xs-12">
                <div className="col-md-4 col-sm-4 text-left">
                  <label className="interview-input-label">{ part_fields[1].display_left }</label>
                </div>  
                <div className="col-md-5 col-sm-5 ">
                  <input
                    key="sp_special_part_5_1"
                    type="number"
                    id="sp_special_part_5_1"
                    className="form-control"
                    placeholder={part_fields[1].placeholder}
                  />
                </div>
                <div className="col-md-3 col-sm-3 text-right">
                  <label className="interview-input-label">{ part_fields[1].display_right }</label>
                </div>  
              </div>

              <div className="col-xs-12">
                <div className="col-md-4 col-sm-4 text-left">
                  <label className="interview-input-label">{ part_fields[2].display_left }</label>
                </div>  
                <div className="col-md-5 col-sm-5">
                  <input
                    key="sp_special_part_5_2"
                    type="number"
                    id="sp_special_part_5_2"
                    className="form-control"
                    placeholder={part_fields[2].placeholder}
                  />
                </div>
                <div className="col-md-3 col-sm-3  text-right">
                  <label className="interview-input-label">{ part_fields[2].display_right }</label>
                </div>
              </div>

              <div className="col-xs-12">
                <input 
                  key="sp_special_part_5_0_2"
                  type="radio" 
                  name="optradio_sp" 
                  className="display-none interview-radio" 
                  id="sp_special_part_5_0_2"
                />
                <label htmlFor="sp_special_part_5_0_2" className="radio-button">{part_fields[0].m_part_field_options[2].title}</label>
              </div>

              <div className="col-xs-12">
                <div className="col-md-5 col-sm-5 text-left">
                  <label className="interview-input-label">{ part_fields[3].display_left }</label>
                </div>  

                <div className="col-md-5 col-sm-5">
                  <input
                    key="sp_special_part_5_0_3"
                    type="number"
                    id="sp_special_part_5_0_3"
                    className="form-control"
                    placeholder={part_fields[3].placeholder}
                  />
                </div>

                <div className="col-md-2 col-sm-2 text-right">
                  <label className="interview-input-label">{ part_fields[3].display_right}</label>
                </div>  
              </div>

            </div>
            
            {/* スマホ以外 */}
            <table className="d-xs-none">
              <thead/>
              <tbody>
                <tr>
                  <td className="col-md-6 col-sm-6">
                      <input 
                        key="special_part_5_0_0"
                        type="radio" 
                        name="optradio" 
                        className="display-none interview-radio" 
                        id="sp_special_part_5_0_0"
                      />
                      <label htmlFor="sp_special_part_5_0_0" className="radio-button">{part_fields[0].m_part_field_options[0].title}</label>
                  </td>
                  <td className="col-md-6 col-sm-6" />
                </tr>

                <tr>
                  <td className="col-md-6 col-sm-6">
                      <input 
                        key="special_part_5_0_1"
                        type="radio"
                        name="optradio" 
                        className="display-none interview-radio" 
                        id="special_part_5_0_1"
                      />
                      <label htmlFor="special_part_5_0_1" className="radio-button">{part_fields[0].m_part_field_options[1].title}</label>
                  </td>

                  <td className="col-md-6 col-sm-6 text-center">
                    <div className="row interview-input-form">
                      <div className="col-md-4 col-sm-4 text-right">
                        <label className="interview-input-label">{ part_fields[1].display_left }</label>
                      </div>  
                      <div className="col-md-5 col-sm-5 ">
                        <input
                          key="special_part_5_1"
                          type="number"
                          id="special_part_5_1"
                          className="form-control"
                          placeholder={part_fields[1].placeholder}
                          min={part_fields[1].validate_value_min}
                        />
                      </div>
                      <div className="col-md-3 col-sm-3 text-left">
                        <label className="interview-input-label">{ part_fields[1].display_right }</label>
                      </div>  

                      <div className="col-md-4 col-sm-4 text-right">
                        <label className="interview-input-label">{ part_fields[2].display_left }</label>
                      </div>  
                      <div className="col-md-5 col-sm-5">
                        <input
                          key="special_part_5_2"
                          type="number"
                          id="special_part_5_2"
                          className="form-control"
                          placeholder={part_fields[2].placeholder}
                          min={part_fields[2].validate_value_min}
                          max={part_fields[2].validate_value_max}
                        />
                      </div>
                      <div className="col-md-3 col-sm-3  text-left">
                        <label className="interview-input-label">{ part_fields[2].display_right }</label>
                      </div>
                    
                    </div>
                    
                  </td>
                </tr>
                <tr>
                  <td className="col-md-6 col-sm-6 ">
                      <input 
                        key="special_part_5_0_2"
                        type="radio" 
                        name="optradio" 
                        className="display-none interview-radio" 
                        id="special_part_5_0_2"
                      />
                      <label htmlFor="special_part_5_0_2" className="radio-button">{part_fields[0].m_part_field_options[2].title}</label>
                  </td>
                  <td className="col-md-6 col-sm-6 text-center">
                    <div className="row interview-input-form">

                      <div className="col-md-5 col-sm-5 text-right">
                        <label className="interview-input-label">{ part_fields[3].display_left }</label>
                      </div>  

                      <div className="col-md-5 col-sm-5">
                        <input
                          key="special_part_5_3"
                          type="number"
                          id="special_part_5_3"
                          className="form-control"
                          placeholder={part_fields[3].placeholder}
                          min={part_fields[3].validate_value_min}
                          max={part_fields[3].validate_value_max}
                        />
                      </div>

                      <div className="col-md-2 col-sm-2 text-left">
                        <label className="interview-input-label">{ part_fields[3].display_right}</label>
                      </div>  

                    
                    </div>
                    
                  </td>
                </tr>
              </tbody>
            </table>
          </>
          )   
      case 6:
        return(
          <>
            {/* スマホ */}
            <div className="d-none">

                  <div className="col-xs-12">
                    <input 
                        key="sp_special_part_6_0_0"
                        type="radio" 
                        name="optradio_sp" 
                        className="display-none interview-radio" 
                        id="sp_special_part_6_0_0"
                      />
                      <label htmlFor="sp_special_part_6_0_0" className="radio-button">{part_fields[0].m_part_field_options[0].title}</label>
                  </div>

                  <div className="col-xs-12">
                    <input 
                        key="sp_special_part_6_0_1"
                        type="radio" 
                        name="optradio_sp" 
                        className="display-none interview-radio" 
                        id="sp_special_part_6_0_1"
                    />
                    <label htmlFor="sp_special_part_6_0_1" className="radio-button">{part_fields[0].m_part_field_options[1].title}</label>
                  </div>

                  <div className="col-xs-12">
                    <div className="row interview-input-form">
                      <div className="col-xs-12 text-left">
                        <label className="interview-input-label">{ part_fields[1].display_left }</label>
                      </div>  
                      <div className="col-xs-12">
                        <input
                          key="sp_special_part_6_1"
                          type="date"
                          id="sp_special_part_6_1"
                          className="form-control"
                          placeholder={part_fields[1].placeholder}
                        />
                      </div>
                    </div>
                  </div>


                  <div className="col-xs-12">
                    <input 
                      key="sp_special_part_6_0_2"
                      type="radio" 
                      name="optradio_sp" 
                      className="display-none interview-radio" 
                      id="sp_special_part_6_0_2"
                    />
                    <label htmlFor="sp_special_part_6_0_2" className="radio-button">{part_fields[0].m_part_field_options[2].title}</label>
                  </div>
            </div>

            {/* スマホ以外 */}
            <table className="d-xs-none">
              <thead/>
              <tbody>
                <tr>
                  <td className="col-md-6 col-sm-6 col-xs-6">
                    <input 
                        key="special_part_6_0_0"
                        type="radio" 
                        name="optradio" 
                        className="display-none interview-radio" 
                        id="special_part_6_0_0"
                      />
                      <label htmlFor="special_part_6_0_0" className="radio-button">{part_fields[0].m_part_field_options[0].title}</label>
                  </td>
                  <td className="col-md-6 col-sm-6 col-xs-6"/>
                </tr>
                <tr>
                  <td className="col-md-6 col-sm-6 col-xs-6">
                    <input 
                        key="special_part_6_0_1"
                        type="radio" 
                        name="optradio" 
                        className="display-none interview-radio" 
                        id="special_part_6_0_1"
                    />
                    <label htmlFor="special_part_6_0_1" className="radio-button">{part_fields[0].m_part_field_options[1].title}</label>
                  </td>
                  <td className="col-md-6 col-sm-6 col-xs-6">
                    <div className="row interview-input-form">
                      <div className="col-md-4 col-sm-4 col-xs-12 text-right">
                        <label className="interview-input-label">{ part_fields[1].display_left }</label>
                      </div>  
                      <div className="col-md-8 col-sm-8 col-xs-12">
                        <input
                          key="special_part_6_1"
                          type="date"
                          id="special_part_6_1"
                          className="form-control"
                          placeholder={part_fields[1].placeholder}
                        />
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="col-md-6 col-sm-6 col-xs-6">
                    <input 
                      key="special_part_6_0_2"
                      type="radio" 
                      name="optradio" 
                      className="display-none interview-radio" 
                      id="special_part_6_0_2"
                    />
                    <label htmlFor="special_part_6_0_2" className="radio-button">{part_fields[0].m_part_field_options[2].title}</label>
                  </td>
                  <td className="col-md-6 col-sm-6 col-xs-6"/>
                </tr>
              </tbody>
            </table>
          </>
        )
        case 7:
          return(
            <>
              {/* スマホ */}
              <div className="d-none">

                <div className="col-xs-12">
                  <input 
                      key="sp_special_part_7_0_0"
                      type="radio" 
                      name="optradio_sp" 
                      className="display-none interview-radio" 
                      id="sp_special_part_7_0_0"
                    />
                    <label htmlFor="sp_special_part_7_0_0" className="radio-button">{part_fields[0].m_part_field_options[0].title}</label>
                </div>

                <div className="col-xs-12">
                  <input 
                      key="sp_special_part_7_0_1"
                      type="radio" 
                      name="optradio_sp" 
                      className="display-none interview-radio" 
                      id="sp_special_part_7_0_1"
                  />
                  <label htmlFor="sp_special_part_7_0_1" className="radio-button">{part_fields[0].m_part_field_options[1].title}</label>
                </div>
                <div className="col-xs-12">
                  <div className="row interview-input-form">
                    <div className="col-xs-12 text-left">
                      <label className="interview-input-label">{ part_fields[1].display_left }</label>
                    </div>  
                    <div className="col-xs-12">
                      <input
                        key="sp_special_part_7_1"
                        type="number"
                        id="sp_special_part_7_1"
                        className="form-control"
                        placeholder={part_fields[1].placeholder}
                      />
                    </div>
                  </div>
                </div>
              </div>
            {/* スマホ以外 */}
              <table className="d-xs-none">
                <thead/>
                <tbody>
                  <tr>
                    <td className="col-md-6 col-sm-6 col-xs-6">
                      <input 
                          key="special_part_7_0_0"
                          type="radio" 
                          name="optradio" 
                          className="display-none interview-radio" 
                          id="sp_special_part_7_0_0"
                        />
                        <label htmlFor="sp_special_part_7_0_0" className="radio-button">{part_fields[0].m_part_field_options[0].title}</label>
                    </td>
                    <td className="col-md-6 col-sm-6 col-xs-6"/>
                  </tr>
                  <tr>
                    <td className="col-md-6 col-sm-6 col-xs-6">
                      <input 
                          key="special_part_7_0_1"
                          type="radio" 
                          name="optradio" 
                          className="display-none interview-radio" 
                          id="special_part_7_0_1"
                      />
                      <label htmlFor="special_part_7_0_1" className="radio-button">{part_fields[0].m_part_field_options[1].title}</label>
                    </td>
                    <td className="col-md-6 col-sm-6 col-xs-6">
                      <div className="row interview-input-form">
                        <div className="col-md-5 col-sm-5 col-xs-12 text-right">
                          <label className="interview-input-label">{part_fields[1].display_left }</label>
                        </div>  
                        <div className="col-md-7 col-sm-7 col-xs-12">
                          <input
                            key="special_part_7_1"
                            type="number"
                            id="special_part_7_1"
                            className="form-control"
                            placeholder={part_fields[1].placeholder}
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </>
        )                   
  
    }
  }

  return(
    <div id="preview_modal" className="modal fade" data-keyboard="false" data-backdrop="static" role="dialog">
      <div className="row row-height-flex full margin-all-0">
        <div className="panel panel-defalut col-md-3 col-sm-3 d-xs-none padding-left-0 padding-right-0 border-none margin-all-0">
          <div className="panel-body bg-green height-100">
            
            {/* 名前エリア */}
            <div className="text-center side-name-area">
              <h4>患者名 様</h4>
              <br/>
            </div>
            
            {/* アイコンエリア */}
            <div className="text-center side-icon-area">
              <img src={icon} className="img-circle img-responsive bg-lightgreen side-icon-img" alt="アイコン"></img>
              <br/>
            </div>

            {/* コメントエリア */}
            {props.is_clinic ? (
              <div className="text-center side-comment-area">
                ご来院ありがとうございます。<br/>
                安全な薬物治療を行うために、次の質問にご回答ください。
                <br/>
              </div>
            ):(
              <div className="text-center side-comment-area">
                ご来局ありがとうございます。<br/>
                安全な薬物治療を行うために、次の質問にご回答ください。
                <br/>
              </div>
            )}


            {/* ページエリア */}
            <div className="text-center side-page-area">
              <label className="side-menu-active">プレビュー表示（カテゴリ名）</label>
            </div>

          </div>
        </div>
            <div className="panel panel-defalut col-md-9 col-sm-9 col-xs-12 padding-left-0 padding-right-0 border-none margin-all-0">
              <div className="panel-body bg-subscreen height-100">
                
                {/* タブメニュー */}
                <div className="d-xs-none">
                  <ul className="nav nav-tabs nav-justified height-10">
                    <li className="active bg-subscreen col-md-2" key={1}>
                        <a data-testid="patient_1" className="patient-tab-active" >
                          患者名
                        </a>
                      </li>
                  </ul>
                </div>

                {/* スマホ用タブメニュー */}
                <div className="d-none col-xs-12">
                  <select 
                    className="form-control interview-input-label"
                    id="user_list"
                    value={1}
                  > 
                    <option value={1} key={1}>患者名</option>
                  </select>
                </div>


                <div className="panel panel-defalut col-md-12 col-sm-12 col-xs-12 question-area bg-subscreen scroll" id="contents_area">
                  <div className="panel-body">
                    　<div>
                        <h3 className="question-title">Q.{props.part.display_web_name}</h3>
                        <hr className="border-top-5"/>
                      </div>
                      <div className="">
                        { 
                          props.partFields.map((partField, idx) => {
                            return(
                              props.part.part_kbn === 2 ? 
                                ( 
                                  <>{partFieldView(partField, idx)}</>
                                ):(
                                  <>
                                  { (idx === 0) && (
                                    <>{specialPartFieldView(props.part, props.partFields)}</>
                                  )}
                                  </>
                                )
                            )
                          })
                        }
                      </div> 
                  </div>
                </div>
                <div className="row height-10">
                  <ul className="pager">
                    <div className="col-md-2 col-sm-3 col-xs-5"/>
                    <div className="col-md-8 col-sm-6 col-xs-2" />
                    <div className="col-md-2 col-sm-3 col-xs-5"> 
                      <li className="next">
                        <a className="pager-button" data-dismiss="modal">閉じる</a>
                      </li>
                    </div>  
                  </ul>
                </div>
              </div>  

            </div>

      </div>
    </div>
  )
}

export default modalPreview
